import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  token$ = this.authService.token$;
  footerText: string = '';

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {}
}
